var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-category-list"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._l((_vm.categories),function(categoryItem,index){return [_c('div',{key:index,staticClass:"col-md-6 col-lg-4"},[_c('category-card',{attrs:{"category":categoryItem}})],1)]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }